import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { X } from "lucide-react";
import { galleryImages } from "../mock";

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);

  // Build a richer gallery by duplicating mock items with categories
  const items = [
    ...galleryImages,
    { src: "/image/siteimages/gallery/photo-1651323018466-b36b7df1d2b1.jpg", caption: "Lobster Tail" },
    { src: "/image/siteimages/gallery/photo-1596797038530-2c107229654b.jpg", caption: "Goan Salmon" },
    { src: "/image/siteimages/gallery/pexels-photo-4869334.jpg", caption: "Kerala Curry" },
    { src: "/image/siteimages/gallery/photo-1774656299241-7724832bcb45.jpg", caption: "Chef's Table" }
  ];

  return (
    <>
      <section
        className="relative h-[55vh] min-h-[400px] flex items-center justify-center text-center bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,36,36,0.7), rgba(10,36,36,0.85)), url(/image/siteimages/gallery/photo-1667388969250-1c7220bf3f37.jpg)"
        }}
      >
        <div className="relative pt-20">
          <span className="divider-ornament text-spice-gold">Visual Experience</span>
          <h1 className="font-display text-white text-5xl md:text-6xl lg:text-7xl font-medium mt-5">
            Gallery
          </h1>
          <p className="text-white/75 mt-4 max-w-xl mx-auto text-base px-5">
            A glimpse into the food, ambience and moments that define Sea Spice Kitchen.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-24 bg-cream">
        <div className="max-w-7xl mx-auto px-5 lg:px-10">
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
            {items.map((img, i) => (
              <div
                key={`${img.caption}-${i}`}
                onClick={() => setLightbox(img)}
                className="gallery-item break-inside-avoid cursor-pointer relative group"
              >
                <img src={img.src} alt={img.caption} className="w-full h-auto block" />
                <div className="absolute inset-0 bg-[#0a2424]/0 group-hover:bg-[#0a2424]/55 transition-all duration-500 flex items-end p-5">
                  <span className="text-white text-sm tracking-[0.2em] uppercase opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all">
                    {img.caption}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-sand text-center">
        <div className="max-w-2xl mx-auto px-5">
          <h3 className="font-display text-sea-deep text-3xl md:text-4xl mb-5">
            Want to see more?
          </h3>
          <p className="text-sea-mid/80 mb-7">Follow us on Instagram for the latest dishes and ambience updates.</p>
          <Link to="/reservations">
            <Button className="bg-sea-deep hover:bg-[hsl(184_60%_10%)] text-white rounded-none px-10 h-14 tracking-wide">
              Book Your Table
            </Button>
          </Link>
        </div>
      </section>

      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          className="fixed inset-0 bg-[#0a2424]/95 z-[100] flex items-center justify-center p-6"
        >
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-6 text-white hover:text-spice-gold"
            aria-label="Close"
          >
            <X size={32} />
          </button>
          <img
            src={lightbox.src}
            alt={lightbox.caption}
            className="max-h-[85vh] max-w-[90vw] object-contain"
          />
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/90 text-sm tracking-[0.2em] uppercase">
            {lightbox.caption}
          </div>
        </div>
      )}
    </>
  );
}
